import * as z from 'zod';
import { FORM_FIELD_CHARACTER_LIMITS } from './form-field-character-limits';
import { isValidUrlText } from '@record-fill';

const FORMAT_ERROR = 'Formato incorreto';

function hasAsciiWhitespace(s: string): boolean {
  for (const character of s) {
    switch (character) {
      case ' ':
      case '\t':
      case '\n':
      case '\r':
      case '\f':
      case '\v':
        return true;
      default:
        break;
    }
  }
  return false;
}

export function isFormBuilderEmailValueShape(value: string): boolean {
  if (hasAsciiWhitespace(value)) {
    return false;
  }

  const atIndex = value.indexOf('@');
  if (atIndex <= 0 || atIndex !== value.lastIndexOf('@')) {
    return false;
  }

  const local = value.slice(0, atIndex);
  const domain = value.slice(atIndex + 1);
  if (local.length === 0 || domain.length === 0) {
    return false;
  }

  if (!domain.includes('.')) {
    return false;
  }

  const domainParts = domain.split('.');
  if (domainParts.length < 2) {
    return false;
  }

  for (const domainPart of domainParts) {
    if (domainPart.length === 0) {
      return false;
    }
  }

  return true;
}

export const formBuilderEmailValueFieldSchema = z
  .string()
  .max(FORM_FIELD_CHARACTER_LIMITS.VALUE)
  .superRefine((val, ctx) => {
    const t = val.trim();
    if (!t) return;
    if (!isFormBuilderEmailValueShape(t)) {
      ctx.addIssue({ code: 'custom', message: FORMAT_ERROR });
    }
  });

export const formBuilderUrlValueFieldSchema = z
  .string()
  .max(FORM_FIELD_CHARACTER_LIMITS.VALUE)
  .superRefine((val, ctx) => {
    if (!val.trim()) return;
    if (!isValidUrlText(val)) {
      ctx.addIssue({ code: 'custom', message: FORMAT_ERROR });
    }
  });
